import React, { useState, useEffect } from "react";
import Table from "../components/Table/Table";
import TopNavbar from "../components/TopNavbar/TopNavbar";
import ApiManager from "../ApiManager/ApiManager";
import SearchBar from "../components/SearchBar/SearchBar";
import { useAuth } from "../components/AuthProvider";
import {
  ShowButton,
  ShowComponent,
  hasPermission,
} from "../components/RoleBasedComponents";
import PERMISSIONS from "../permissions";
import Modal from "../components/Modal/Modal";
import ViewEntity from "../components/ViewEntity/ViewEntity";
import EditEntity from "../components/EditEntity/EditEntity";
import NewGarage from "./NewGarage";
import { LoadingSpinner } from "../components/LoadingSpinner/LoadingSpinner";
import { useComponentLoading } from "../utils/useComponentLoading";

function Garages() {
  const { userPermissions } = useAuth();
  const [currentRowId, setCurrentRowId] = useState(null);
  const [data, setData] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDetails, setDetails] = useState(true);
  const [isEdit, setEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  const [garageData, setGarageData] = useState([]);
  const { withLoading, isLoading, getMessage, getProgress } = useComponentLoading();

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const fetchData = async () => {
    try {
      await withLoading('fetchGarages', async (updateProgress) => {
        updateProgress(10, 'Fetching garages...');
        const params = new URLSearchParams({
          page_size: 12,
          page: currentPage,
        });
        const response = await ApiManager.getAllGarages(params);
        if (!response.ok) throw new Error("Failed to fetch garages");
        const cars = await response.json();
        setData(cars);
        setHasMorePages(cars.length == 12);
        updateProgress(100, 'Garages loaded successfully');
      });
    } catch (error) {
      console.error("Error fetching garages:", error);
      setHasMorePages(false);
    }
  };

  const fetchGarageData = async () => {
    try {
      setCurrentRowId(rowId);
      const query = new URLSearchParams({
        id: rowId,
      });
      const response = await ApiManager.getGarage(query);
      if (!response.ok) throw new Error("Network response was not ok");
      const json = await response.json();
      setGarageData(json);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const handleEdit = () => {
    console.log("Edit clicked for row:");
    setDetails(false);
    setEdit(true);
    setModalOpen(true);
    fetchGarageData();
  };

  const handleDetails = () => {
    console.log("Details clicked for row:");
    setDetails(true);
    setEdit(false);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const buttons = [{ label: "Details", onClick: () => handleDetails() }];

  if (hasPermission(userPermissions, PERMISSIONS.VENDOR_GARAGE_UPDATE)) {
    buttons.push({ label: "Edit", onClick: () => handleEdit() });
  }

  const columns = [
    { field: "description", headerName: "Name" },
    { field: "address", headerName: "Address" },
  ];

  const editColumns = [
    { name: "address", label: "Address", type: "text" },
    { name: "description", label: "Name", type: "text" },
    { name: "location", label: "Location", type: "mapinput" },
  ];

  const rows = (data || []).map((item) => ({
    id: item.id,
    address: item.address,
    description: item.description,
  }));

  const handleEditGarage = async (formData) => {
    const updatedFormData = {
      ...formData,
    };

    const query = new URLSearchParams({
      id: currentRowId,
    });
    const response = await ApiManager.updateGarage(
      query,
      updatedFormData
    );
    return response;
  };

  return (
    <div>
      <TopNavbar
        title="Garages"
      />
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          width: "100%",
          paddingTop: "20px",
          height: "5vh",
        }}
      >
        {/* <SearchBar /> */}
        <ShowButton permission={PERMISSIONS.VENDOR_GARAGE_CREATE}>
          <NewGarage onSuccess={fetchData} />
        </ShowButton>
      </div>
        <Table
          table_columns={columns}
          view_columns={columns}
          rows={rows}
          setRowsId={setRowId}
          buttons={buttons}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          hasMorePages={hasMorePages}
          isLoading={isLoading('fetchGarages')}
          loadingMessage={getMessage('fetchGarages')}
          loadingProgress={getProgress('fetchGarages')}
        />

      {isModalOpen && isDetails && (
        <Modal isOpen={true} onClose={handleModalClose}>
          <ViewEntity
            id={rowId}
            fetchFunction={ApiManager.getGarage}
            columns={columns}
            entity="id"
          />
        </Modal>
      )}
      {isModalOpen && isEdit && (
        <Modal isOpen={true} onClose={handleModalClose}>
          <EditEntity
            id={rowId}
            updateFunction={handleEditGarage}
            prevData={garageData}
            columns={editColumns}
            toggleFunction={toggleModal}
            title="Edit Garage"
          />
        </Modal>
      )}
    </div>
  );
}

export default Garages;
